import './DadosPessoais.css';
import { useState } from 'react';
import { useCookies } from "react-cookie";
import { HiOutlineLockClosed } from "react-icons/hi";
import { useNavigate } from 'react-router-dom'
import EtapaDadosPessoais from '../../../components/Banners/EtapaDadosPessoais/EtapaDadosPessoais'
import BannerDadosPessoaisPhone from '../../../components/Banners/BannerDadosPessoaisPhone/BannerDadosPessoaisPhone.js'
import Input from '../../../components/Input/input';
import Button from '../../../components/Button/button';
import axios from 'axios';
import api from '../../../services/api.js';
import Select from 'react-select'
import React from 'react'
import Loading from '../../Loading/Loading.js'
import { ConnectingAirportsOutlined } from '@mui/icons-material';

const optGenero = [
    { value: '', text: 'Selecione' },
    { value: 'M', text: 'Masculino' },
    { value: 'F', text: 'Feminino' }
]

const optEstado = [
    { value: '', text: 'Selecione' },
    { value: 'AC', text: 'AC' },
    { value: 'AL', text: 'AL' },
    { value: 'AP', text: 'AP' },
    { value: 'AM', text: 'AM' },
    { value: 'BA', text: 'BA' },
    { value: 'CE', text: 'CE' },
    { value: 'ES', text: 'ES' },
    { value: 'GO', text: 'GO' },
    { value: 'MA', text: 'MA' },
    { value: 'MT', text: 'MT' },
    { value: 'MS', text: 'MS' },
    { value: 'MG', text: 'MG' },
    { value: 'PA', text: 'PA' },
    { value: 'PB', text: 'PB' },
    { value: 'PR', text: 'PR' },
    { value: 'PE', text: 'PE' },
    { value: 'PI', text: 'PI' },
    { value: 'RJ', text: 'RJ' },
    { value: 'RN', text: 'RN' },
    { value: 'RS', text: 'RS' },
    { value: 'RO', text: 'RO' },
    { value: 'RR', text: 'RR' },
    { value: 'SC', text: 'SC' },
    { value: 'SP', text: 'SP' },
    { value: 'SE', text: 'SE' },
    { value: 'TO', text: 'TO' },
    { value: 'DF', text: 'DF' },  
]

// const optCidade = [{ value: '', text: 'Selecione o UF Naturalidade' }]

function DadosPessoais() {
    const encode_data = sessionStorage.getItem("encode_data")
    
    const [optCidade, setOptCidade] = useState([{ value: '', text: 'Selecione o UF' }]);
    const [optCidadeSort, setOptCidadeSort] = useState([{ value: '', text: 'Selecione' }]);
    
    const [isShow, setShow] = useState(false);
    const [cookies] = useCookies(['__gtm_campaign_url']);
    const [fieldsValidity, setFieldsValidity] = useState([]);
    const [isChecked] = useState(true)
    const [flCidade, setflCidade] = useState(true);
    const [payload, setPayload] = useState([]);
    const navigate = useNavigate();
    const [selected, setSelected] = useState(optEstado[0].value);
    const [selected2, setSelected2] = useState();
    const [selected3, setSelected3] = useState(optGenero[0].value);

    const [frente, setFrente] = useState("Anexo Frente...");
    const [versoDoc, setVersoDoc] = useState("Anexo Verso...");

    const [frenteBase64, setFrenteBase64] = useState("");
    const [versoBase64, setVersoBase64] = useState("");

    const [docType, setDocType] = useState("RG");
    

    const [campoCidade, setCidade] = useState("")

    const imageFrente = e => {
        const files = e.target.files;
        const file = files[0];
        setFrente(file.name);
        getBase64Frente(file);
    };

    const onLoadFrente = fileString => {
        setFrenteBase64(fileString);
        // console.log(fileString);
    };

    const getBase64Frente = file => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            onLoadFrente(reader.result);
        };
    };



    const imageVerso = e => {
        const files = e.target.files;
        const file = files[0];
        setVersoDoc(file.name);
        getBase64Verso(file)
    };

    const onLoadVerso = fileString => {
        setVersoBase64(fileString);
        // console.log(fileString);
    };

    const getBase64Verso = file => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            onLoadVerso(reader.result);
        };
    };


    function carregaMunicipios(estado){
        setShow(true);
        // console.log("UF",estado)

        setSelected(estado);

        axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/municipios`)
        .then(result => {

           
            setOptCidade([]);
            setOptCidadeSort([]);
            
            result.data.forEach((val, index) => {
                // console.log(val.nome)
                optCidade.push(`${val.nome}`)
            });

            const arrCidade = optCidade.sort();

            setOptCidade([]);

            arrCidade.forEach((val, index) => {
                console.log(val.nome)
                optCidadeSort.push({ value: `${val}`, label: `${val}` })
            });
            
            setflCidade(false);

            setCidade("Carregando...");
            
            setTimeout(() => {
                setCidade(carregarCidadesSelect(optCidadeSort))
                setShow(false);
            }, 1000);
            
        })
        .catch((err) => {
            setShow(false);
            console.log("Nao encontrado", estado)
            const errors = [];
            setflCidade(true);
        });
    }


    // SELECT GENERO
    const handleChangeGenero = event => {
        setSelected3(event.target.value);
    };

    // SELECT ESTADO
    const handleChangeUF = event => {
        setSelected(event.target.value);
    };
    
    function convertCookie(cookieUrl) {
        const rawParams = cookieUrl?.split("?")?.[1]?.split("&");
        const wantedParams = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "aff_click_id",
        ];

        const cleanParams = {}

        if (rawParams) {
            for (const rawParam of rawParams) {

                const [key, value] = rawParam.split("=");

                if (key === 'aff_click_id') {
                    axios.get(`https://api.vsboon.com.br/reward/delivery/savvi?aff_click_id=${value}&action_type=Inapp`)
                        .then(() => {
                            //   console.log('deu certo')
                        })
                        .catch(() => {
                            //   console.log('deu errado')
                        })
                }
                if (key && value && wantedParams.includes(key)) {

                    cleanParams[key] = value;
                }
            }
            return cleanParams;
        }

        return {};
    }

    let buttonContinuar = document.querySelector(".btnContinuar");
    let btnContinuar = "btnContinuar"
    let btnVoltar = "btnVoltar"
    async function handleSubmit(e) {
        e.preventDefault();
        const errors = handleOnBlur(payload, "submit");

        if (errors.length === 0) {
            const nome_mae = payload.nomeMae;
            const sexoElem = document.getElementById("genero");
            const sexo = sexoElem.value;
            const ufElem = document.getElementById("estado");


            // const cidadeElem = document.getElementById("cidade");
            const cidadeElem = document.querySelector("#cidade .css-1dimb5e-singleValue");

            const identidade = {
                uf: ufElem.value,
                cidade: cidadeElem.textContent,
                tipo: docType,
                numero: payload.numeroRg,
                cidade_nasc: cidadeElem.value,
            };

            const rg_image_frente = frenteBase64
            const rg_image_verso = versoBase64

            const cookieParams = convertCookie(cookies.__gtm_campaign_url);
            const sendbackend = {
                nome_mae,
                sexo,
                identidade,
                rg_image_frente,
                rg_image_verso,

                utm_campaign: (cookieParams.utm_campaign || ""),
                utm_medium: (cookieParams.utm_medium || ""),
                utm_source: (cookieParams.utm_source || ""),
                utm_id: (cookieParams.utm_id || ""),
                utm_content: (cookieParams.utm_content || ""),
                utm_term: (cookieParams.utm_term || ""),
                gclid: (cookieParams.gclid || ""),
                fbclid: (cookieParams.fbclid || ""),
                aff_click_id: (cookieParams.aff_click_id || ""),
            }
            
            const JsonArray = JSON.stringify(sendbackend)
            const json_obj = JSON.parse(JsonArray)
            console.log(json_obj);

            
            setShow(true);

            api.put(`/crefaz/update/${encode_data}`, json_obj, {

            }).then((response) => {
                    window.dataLayer.push({
                        event: "fgts-form-success",
                        "address.country": "Br",
                    });
                    const encode = response.data.encode_data
                    const id = response.data.id
                    sessionStorage.setItem("encode_data", encode);
                    sessionStorage.setItem("id", id);
                    setShow(false);
                    navigate("/dados-bancario")
                })
                .catch(() => {
                    console.log("erro")
                    navigate("/contato")
                    setShow(false);
                    buttonContinuar.disabled = false;
                })
        } 
    }
    const handleOnBlur = (e, prop) => {
        const errors = [];
        if ((prop === "numeroRg" && !e?.target?.value) || (prop === "submit" && !e?.numeroRg)) {
            errors.push({
                prop: "numeroRg",
                errorMessage: "Digite um valor válido no campo"
            })
        }

        if ((prop === "nomeMae" && !e?.target?.value) || (prop === "submit" && !e?.nomeMae)) {
            errors.push({
                prop: "nomeMae",
                errorMessage: "Digite um valor válido no campo"
            })
        }

        // if ((prop === "cidade" && !e?.target?.value) || (prop === "submit" && !e?.cidade)) {
        //    errors.push({
        //        prop: "cidade",
        //        errorMessage: "Digite um valor válido no campo"
        //    })
        // }

    
       
        setFieldsValidity(errors)

        return errors;
    }

    const handleChangeInputs = (value, prop) => {
        setPayload({ ...payload, [prop]: value })
    }
    
    function carregarCidadesSelect (cidades) {
        // console.log(cidades);
        return (
            <Select
            
               value={payload.cidade}
               id='cidade'
               name="cidade"
               type="text"
               placeholder='Selecione'
               className="selSel"
               length="20"
               error={fieldsValidity}
               handleOnBlur={handleOnBlur}

               onChange={(event) =>
                alerta(event.target)
               }
               
               options={cidades} />
        );
    }

    function alerta(event){
        console.log(event);
    }

    const exceptThisSymbols = ["+", "-", ".", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "=", "!", "@", "#", "$", "%", "&", "*", "(", ")", "_", "[", "]", "{", "}", "'", "?", "/"];
    return (
        <div className="home">
            <div className='mobile'>{isShow && <Loading />}</div>
            <EtapaDadosPessoais />
            <BannerDadosPessoaisPhone />
            <form className='container2' onSubmit={handleSubmit}>
                <div className='form'>
                    <div className='titleform'>
                        <h4 className='titleMob'>Dados Pessoais</h4>
                    </div>
                    

                    <div className='Input-form'>
                        <div className=''>
                            <label className='label'><b>Tipo de Documento</b></label>
                            <div className="inputRadio lfLeft">
                                <label for="lbRG">RG</label>
                                <input type="radio" value="RG" name="documento" id="lbRG" checked="true" onClick={() => setDocType("RG")} />
                            </div>

                            <div className="inputRadio lfRight">
                                <label for="lbCNH">CNH</label>
                                <input type="radio" value="Feminino" name="documento" id="lbCNH" onClick={() => setDocType("CNH")} />
                            </div>
                        </div>
                        <div className='spaceform'></div>


                        <div className='group'>
                            <label className='label'><b>Número {docType}</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value.replace(/\D/,''), "numeroRg")}
                                value={payload.numeroRg}
                                name="numeroRg"
                                type="text"
                                placeholder="Digite o número"
                                length="9"
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                            />
                        </div>


                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>Nome da mãe</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "nomeMae")}
                                value={payload.nomeMae}
                                name="nomeMae"
                                type="text"
                                placeholder='Nome da mãe'
                                length="9"
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                            />
                        </div>


                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>Gênero</b></label>
                            <div class="cmpSelect">
                                <select 
                                    id="genero"
                                    name="genero"
                                    className="selSel"
                                    value={selected3}
                                    onChange={handleChangeGenero}
                                    error={fieldsValidity}
                                    handleOnBlur={handleOnBlur}>
                                    {
                                        optGenero.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.text}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>UF Naturalidade</b></label>
                            <div class="cmpSelect">
                                <select 
                                    id="estado"
                                    name="estado"
                                    className="selSel"
                                    value={selected}
                                    onChange={(event) =>carregaMunicipios(event.target.value) }
                                    error={fieldsValidity}
                                    handleOnBlur={handleOnBlur}>
                                    {
                                        optEstado.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.text}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='spaceform'></div>
                            <div className='group'>
                                <label className='label'><b>Cidade Naturalidade</b></label>
                                <div class="cmpSelect">
                                    {campoCidade}
                                </div>
                        </div>


                        <div className='contaLuzText'>Por favor, anexe uma foto da frente e uma do verso do seu documento</div>
                        <div className='contaLuzTextInfo'>Atenção: tire o documento do plástico e faça a foto em local com boa iluminação .</div>


                        <label className='label'><b>Frente</b> <span className="labelInfo">(foto da frente do documento)</span></label>
                        <div className='groupUpload'>{frente}</div>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile" onChange={imageFrente}/>
                            <label class="custom-file-input" for="customFile">Anexar</label>
                        </div>

                            
                        <div className='spaceform'></div>
                        <label className='label'><b>Verso</b> <span className="labelInfo">(foto do verso do documento)</span></label>
                        <div className='groupUpload'>{versoDoc}</div>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile2" onChange={imageVerso} />
                            <label class="custom-file-input" for="customFile2">Anexar</label>
                        </div>


                        <div className='spaceform'></div>

                        <Button
                            message='CONTINUAR'
                            className={btnContinuar}
                            isChecked={isChecked}
                        />

                        <button
                            className={btnVoltar}
                            cursor='pointer'
                            onClick={() => navigate("/dados-conta")}>
                            VOLTAR
                        </button>

                        <div className='space1'></div>
                    </div>

                    <div className='textfooter-phones'>
                            <div className='locked-phones'><HiOutlineLockClosed /></div>
                            <h6>Você está em um ambiente seguro.</h6>
                        </div>

                </div>
            </form >
        </div >
    );
}

export default DadosPessoais;